export enum Dashboard {
  View = 'View',
}

export enum Timeline {
  View = 'View',
}

export enum Jobs {
  View = 'View',
  Calendar = 'Calendar',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  ChangeProfile = 'ChangeProfile',
  Cancel = 'Cancel',
  Route = 'Route',
  Import = 'import',
  ManualRoute = 'manualRoute',
  Distributing = 'Distributing',
}

export enum Holidays {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum MissionControl {
  View = 'View',
  BuildScenario = 'BuildScenario',
}

export enum Trips {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Decline = 'Decline',
  Accept = 'Accept',
  Delete = 'Delete',
  Assign = 'Assign',
  SendTrip = 'SendTrip',
  AddNote = 'AddNote',
  SendMessage = 'SendMessage',
  ExportTrip = 'ExportTrip',
  ChangeStatus = 'ChangeStatus',
  CombineTrip = 'CombineTrip',
  Merge = 'Merge',
  Cancel = 'Cancel',
}

export enum Drivers {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  ChangeStatus = 'ChangeStatus',
  Import = 'import',
}

export enum OnlineDrivers {
  View = 'View',
  Edit = 'Modify',
}

export enum Students {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  ChangeStatus = 'ChangeStatus',
}

export enum ActiveDrivers {
  View = 'View',
}

export enum Passengers {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  Import = 'import',
}

export enum Parents {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  Import = 'import',
}

export enum Caregivers {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  Import = 'import',
}

export enum Vehicles {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  Import = 'import',
}

export enum CustomRules {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum LiveMap {
  View = 'View',
}

export enum DriverShifts {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum DriverShiftsTemplates {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Reports {
  View = 'View',
}

export enum Analytics {
  View = 'View',
}

export enum Services {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Locations {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  Import = 'import',
}

export enum AreasZonePricing {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum AreasRoutingZones {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Rates {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum RateTypes {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum ExtraServices {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Suppliers {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Users {
  View = 'View',
  Invite = 'Invite',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Invitations {
  View = 'View',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Profiles {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum History {
  View = 'View',
}

export enum Shifts {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Fares {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Areas {
  Import = 'import',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  View = 'View',
}

export enum JenniAI {
  Active = 'active',
}

export enum Shuttles {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
  AddTime = 'addTime',
  AddStop = 'addStop',
}

export enum PassengerShuttlesWebApp {
  Active = 'active',
}

export enum PassengersWebPortal {
  Active = 'active',
}

export enum RoutingScheduler {
  Active = 'active',
}

export enum PredictiveETA {
  Active = 'active',
}

export enum PredictiveETANotifications {
  Active = 'active',
}

export enum WhiteLabelSolution {
  Active = 'active',
}

export enum ApiAccess {
  Active = 'active',
}

export enum TestPageAccess {
  Active = 'active',
}

export enum EditSites {
  Active = 'active',
}

export enum Sites {
  Delete = 'Delete',
}

export enum Attributes {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum Automations {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum DataUpload {
  Import = 'Import',
}

export enum CardBlacklist {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}

export enum ApiKeys {
  View = 'View',
  Create = 'Create',
  Edit = 'Modify',
  Delete = 'Delete',
}
